// extracted by mini-css-extract-plugin
export var buttons = "StockTransferConfirmModal-module--buttons--XKS3r";
export var container = "StockTransferConfirmModal-module--container--9Afe3";
export var date = "StockTransferConfirmModal-module--date--5DMMC";
export var welcomeContent = "StockTransferConfirmModal-module--welcomeContent--y9MO3";